import api from '@/lib/api'

const state = () => ({
  allUsers: [],
})

const getters = {
  allUsers: state => state.allUsers,
}

const actions = { 
  async loadAll({ commit }) {
    const result = await api.get(`/users`)

    if(result.ok) {
      commit('SET_ALL', await result.json())
      return { ok: true }
    }

    return { ...await result.json(), status: result.status, ok: false }
  },

  async createUser ({ dispatch }, user) {
    // wrap user this way to make rails happy
    const result = await api.post(`/users`, { user })

    if(result.ok) {
      dispatch('loadAll')
      return { ok: true, updated: await result.json() }
    }

    return { ...await result.json(), status: result.status, ok: false }
  },

  async updateUser ({ dispatch }, { pro_user_id, ...user }) {
    const result = await api.put(`/users/${pro_user_id}`, { user })

    if(result.ok) {
      dispatch('loadAll')
      return { ok: true, updated: await result.json() }
    }

    return { ...await result.json(), status: result.status, ok: false }
  },

  async deleteUser ({ dispatch }, { pro_user_id } ) {
    const result = await api.delete(`/users/${pro_user_id}`)

    if(result.ok) {
      dispatch('loadAll')
      return { ok: true }
    }

    return { ...await result.json(), status: result.status, ok: false }
  },

  async logoutUser ({ dispatch }, { pro_user_id }) {
    const result = await api.put(`/users/${pro_user_id}/logout`)

    if(result.ok) {
      dispatch('loadAll')
      return { ok: true }
    }

    return { ...await result.json(), status: result.status, ok: false }
  },

  // eslint-disable-next-line no-empty-pattern
  async remindUser ({ }, { pro_user_id } ) {
    const result = await api.put(`/users/${pro_user_id}/remind`)

    if(result.ok) {
      return { ok: true }
    }

    return { ...await result.json(), status: result.status, ok: false }
  },
}

const mutations = {
  SET_ALL: (state, users) => state.allUsers = users,
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}